export default "__VITE_ASSET__30bba67f__"